import React from 'react';
import { ExplorerItem } from './types';
interface CompactRowProps {
  item: ExplorerItem;
  onClick: () => void;
  accentColor?: 'blue' | 'purple';
}
export function CompactRow({
  item,
  onClick,
  accentColor = 'blue'
}: CompactRowProps) {
  const Icon = item.icon;
  const isActive = item.usageCount > 0;
  const accentClass = accentColor === 'blue' ? 'text-blue-600 bg-blue-50' : 'text-purple-600 bg-purple-50';
  const hoverClass = accentColor === 'blue' ? 'hover:border-blue-300' : 'hover:border-purple-300';
  const countClass = accentColor === 'blue' ? 'text-blue-600' : 'text-purple-600';
  return <div onClick={isActive ? onClick : undefined} className={`flex items-center justify-between px-2.5 sm:p-3 py-2 sm:py-3 rounded-lg border transition-all gap-2 ${isActive ? `bg-white border-gray-200 cursor-pointer ${hoverClass} hover:shadow-sm` : 'bg-gray-50/50 border-gray-100 opacity-60 cursor-not-allowed'}`} data-id="element-6194" data-mp="d2mzzge3i2at">
      <div className="flex items-center gap-2.5 sm:gap-4 min-w-0 flex-1" data-id="element-6195" data-mp="3lgvjlyyn3iqu">
        <div className={`w-7 h-7 sm:w-8 sm:h-8 rounded-lg flex items-center justify-center shrink-0 ${isActive ? accentClass : 'bg-gray-200 text-gray-400'}`} data-id="element-6196" data-mp="txztg63ric8d">
          <Icon className="w-3.5 h-3.5 sm:w-4 sm:h-4" data-id="element-6197" data-mp="k7od1k2w6akl" />
        </div>
        <div className="min-w-0 flex-1" data-id="element-6198" data-mp="f9whmg31g6bn">
          <div className="flex items-center gap-1.5 sm:gap-2 min-w-0" data-id="element-6199" data-mp="f8tqq85pu3vq">
            <code className="text-xs sm:text-sm font-mono font-bold text-gray-900 truncate" data-id="element-6200" data-mp="aasb5x7i0mp0">
              {item.id}
            </code>
            {!item.isRegistered && <span className="text-[9px] sm:text-[10px] bg-red-100 text-red-700 px-1 sm:px-1.5 py-0.5 rounded font-bold shrink-0" data-id="element-6201" data-mp="19u2h1m47r03">
                Unreg
              </span>}
          </div>
          <p className="text-[11px] sm:text-xs text-gray-500 line-clamp-1" data-id="element-6202" data-mp="1vnmqe053rirm">
            {item.description}
          </p>
        </div>
      </div>

      <div className="flex items-center gap-2 sm:gap-6 shrink-0" data-id="element-6203" data-mp="1qq390rd3ypvg">
        {/* Module badges — visible on tablet+ */}
        <div className="hidden md:flex flex-wrap gap-1 justify-end max-w-[10rem]" data-id="element-6204" data-mp="3l3p835lqzt6h">
          {Array.from(item.modules).slice(0, 3).map(m => <span key={m} className="text-[10px] font-bold px-1.5 py-0.5 rounded border bg-gray-50 border-gray-200 text-gray-600" data-id="element-6205" data-mp="3b85fot6e7cmh">
                {m}
              </span>)}
          {item.modules.size > 3 && <span className="text-[10px] text-gray-400 font-medium px-1" data-id="element-6206" data-mp="cpqdo8efcfv3">
              +{item.modules.size - 3}
            </span>}
        </div>

        {/* Stats */}
        <div className="text-right min-w-[2.5rem] sm:min-w-[4rem]" data-id="element-6207" data-mp="2r102rtk9hkn">
          <div className={`text-sm font-black ${isActive ? countClass : 'text-gray-400'}`} data-id="element-6208" data-mp="2p6dl92n5heg">
            {item.usageCount}
          </div>
          <div className="text-[10px] text-gray-500 font-medium" data-id="element-6209" data-mp="2nib5kjdgk25x">refs</div>
        </div>
      </div>
    </div>;
}